import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});

export const listingCard = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '1x',
  cursor: 'pointer',
  textDecoration: 'none',
  color: 'inherit',
  _hover: {
    '& img': {
      opacity: 0.9,
    },
  },
});

export const listingImage = css({
  width: '100%',
  aspectRatio: '4/3',
  objectFit: 'cover',
  borderRadius: '8px',
  backgroundColor: 'hpxGrey100',
});

export const noPhotoPlaceholder = css({
  width: '100%',
  aspectRatio: '4/3',
  borderRadius: '8px',
  backgroundColor: 'hpxGrey100',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'hpxGrey500',
  fontSize: 'tiny',
});

export const listingName = css({
  fontSize: 'sm',
  fontWeight: '600',
  color: 'hpxBlue600',
  lineHeight: '1.3',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const listingPrice = css({
  fontSize: 'sm',
  color: 'hpxBlue500',
});

export const areaLinkContainer = css({
  display: 'flex',
  justifyContent: 'flex-end',
  paddingTop: '1x',
});

export const areaLink = css({
  fontSize: 'sm',
  fontWeight: '600',
  color: 'hpxTeal500',
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: 'xs',
  _hover: {
    color: 'hpxTeal600',
    textDecoration: 'underline',
  },
});
